import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LoadingSpinner } from '../../components/common/LoadingSpinner';

export const AuthCallback = () => {
  const { handleOAuthCallback } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id found in callback');
        navigate('/login');
        return;
      }

      const result = await handleOAuthCallback(sessionId);

      if (result.success) {
        // Clear the hash
        window.history.replaceState(null, '', window.location.pathname);
        
        // Check if this is a new user who needs to select a subscription
        // New users from OAuth may not have a subscription plan yet
        if (result.user?.needs_subscription_selection || !result.user?.subscription_plan) {
          navigate('/select-plan', { replace: true });
        } else {
          navigate('/dashboard', { replace: true, state: { user: result.user } });
        }
      } else {
        navigate('/login');
      }
    };

    processCallback();
  }, [handleOAuthCallback, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-slate-600">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
